module.exports = __webpack_public_path__ + "static/media/icon-minus.99d4cf85.svg";